module.exports = __webpack_public_path__ + "static/media/car-service-ok.abdd8876.svg";